import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
export const getPinnedAutomationLatestRunLinksQueryKey = () => [
    'sidebar-pinned-automation-latest-run-links',
];
export const AUTOMATION_HAS_UNREAD_PATH = '/rest/automations/has_unread';
export const getAutomationHasUnreadQueryKey = () => QueryClientHelper.makeQueryKey(AUTOMATION_HAS_UNREAD_PATH);
export const AUTOMATION_SHARING_PATH = '/rest/automations/{automation_id}/sharing';
export const getAutomationSharingQueryKey = (automationId) => QueryClientHelper.makeQueryKey(AUTOMATION_SHARING_PATH, automationId);
//# sourceMappingURL=automationKeys.js.map